module.exports = "/_next/static/images/OgGrowthReport-ff0a58a87b99f7ccec5d67ace5e050a1.png";